<template>
  <div>
    <b-button
      v-if="!inline && selectedFilters && selectedFilters.length > 0"
      size="sm"
      class="ml-2"
      variant="outline-secondary"
      @click="clearFilters"
    >
      <Icon icon="times" size="14" />
      {{ __('buttons.clear-filters') }}
    </b-button>

    <b-dropdown
      v-if="!inline"
      ref="dropdown"
      size="sm"
      variant="outline-primary"
      no-caret
      class="ml-2"
      :left="placement === 'left'"
      :right="placement === 'right'"
      menu-class="dropdown-menu-custom"
      @hide="handleDropdownHide"
      @hidden="handleDropdownHidden"
    >
      <template #button-content>
        <Icon icon="list-ui-alt" size="14" />
        {{ __('buttons.filter') }}
        <b-badge
          v-if="selectedFilters && selectedFilters.length > 0"
          variant="soft-primary"
          class="ml-1"
        >
          {{ selectedFilters.length }}
        </b-badge>
      </template>
      <b-dropdown-text class="filter-header">
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ __('buttons.filter') }}</span>

          <b-button
            v-if="selectedFilters && selectedFilters.length > 0"
            size="sm"
            variant="outline-secondary"
            @click="clearFilters"
          >
            {{ __('buttons.clear-all') }}
          </b-button>
        </div>
      </b-dropdown-text>
      <b-dropdown-form style="min-width: 285px">
        <slot name="filters"></slot>
        <div>
          <b-button variant="primary" class="mr-2" size="sm" @click="onSave">
            <Icon icon="check" class="mr-2" size="14" />
            {{ __('buttons.apply') }}
          </b-button>

          <b-button variant="outline-secondary" size="sm" @click="onCancel">
            <Icon icon="times" class="mr-2" size="14" />
            {{ __('buttons.cancel') }}
          </b-button>
        </div>
      </b-dropdown-form>
    </b-dropdown>

    <div v-else class="inline-filters">
      <div class="d-flex align-items-center">
        <b-button
          v-if="inline && selectedFilters && selectedFilters.length > 0"
          size="sm"
          class="mr-2"
          variant="outline-secondary"
          @click="clearFilters"
        >
          <Icon icon="times" size="14" />
          {{ __('buttons.clear-filters') }}
        </b-button>

        <slot name="filters" :apply-filters="applyFilters" />

        <b-button variant="primary" class="ml-2" size="sm" @click="onSave">
          <Icon icon="check" class="mr-2" size="14" />
          {{ __('buttons.apply') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  OPERATOR_IN,
  OPERATOR_LIKE,
  OPERATOR_BETWEEN,
  OPERATOR_EQUALS,
  OPERATOR_IS_NULL,
  OPERATOR_ACTION_IN,
} from '@/General/Tables/FilterManager.js'

export default {
  name: 'DataFilter',

  props: {
    placement: {
      type: String,
      default: 'right',
    },
    filters: {
      type: Array,
      default: () => {
        return []
      },
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedFilters: {
        type: Array,
        default: () => {
          return []
        },
      },
      preventDropdownClose: true,
    }
  },

  watch: {
    filters: {
      handler() {
        this.updateSelectedFilters()
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    handleDropdownHide(bvEvent) {
      if (this.preventDropdownClose) {
        bvEvent.preventDefault()
      }
    },
    handleDropdownHidden() {
      this.preventDropdownClose = true
    },
    close() {
      this.preventDropdownClose = false
      this.$nextTick(() => {
        if (this.inline) {
          return
        }

        this.$refs.dropdown.hide(true)
      })
    },
    onSave() {
      this.applyFilters()
    },
    onCancel() {
      this.close()
    },
    applyFilters() {
      this.$emit('applyFilters')
      this.close()
      this.updateSelectedFilters()
    },
    clearFilters() {
      this.$emit('clearFilters')
      this.close()
      this.updateSelectedFilters()
    },
    updateSelectedFilters() {
      const newFilters = this.filters
        .filter(
          (item) =>
            item &&
            [
              OPERATOR_IN,
              OPERATOR_LIKE,
              OPERATOR_BETWEEN,
              OPERATOR_EQUALS,
              OPERATOR_IS_NULL,
              OPERATOR_ACTION_IN,
            ].includes(item.operator)
        )
        .filter(({ value }) => (_.isArray(value) ? value.length > 0 : !!value))
      this.selectedFilters = [...newFilters]
    },
  },
}
</script>
<style lang="scss">
.dropdown-menu-custom {
  border: 1px solid #d5e5fa;
  box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 12%);
  padding-top: 0;

  .filter-header {
    border-bottom: 1px solid #d5e5fa;
    padding: 10px 0;
    margin-bottom: 13px;
    background-color: #f9fbfd;
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;

    .b-dropdown-text {
      color: #95aac9;
      text-transform: uppercase;
      font-size: 0.6875rem;
      font-weight: 600;
      letter-spacing: 0.08em;
    }
  }
}

.inline-filters {
  .form-group {
    margin-bottom: 0 !important;
  }
}
</style>
